import { render, staticRenderFns } from "./ResetPasswordDialog.vue?vue&type=template&id=65c6cf2a&scoped=true"
import script from "./ResetPasswordDialog.vue?vue&type=script&lang=js"
export * from "./ResetPasswordDialog.vue?vue&type=script&lang=js"
import style0 from "./ResetPasswordDialog.vue?vue&type=style&index=0&id=65c6cf2a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65c6cf2a",
  null
  
)

export default component.exports